import React from "react";
import { useNavigate } from "react-router-dom";
import { isMaintenanceMode, isSuperAdmin } from "./MaintenanceGuard";
import { Wrench } from "lucide-react";

const MaintenanceEntryButton: React.FC = () => {
  const navigate = useNavigate();

  if (!isMaintenanceMode() || !isSuperAdmin()) return null;

  // Hide when already on a maintenance page — sidebar handles navigation there
  if (window.location.pathname.startsWith("/maintenance")) return null;

  return (
    <button
      onClick={() => navigate("/maintenance/stations")}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 18px",
        background: "#1a1a2e",
        color: "#fff",
        border: "2px solid #5554d3",
        borderRadius: 28,
        fontSize: 14,
        fontWeight: 600,
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      }}
    >
      <Wrench size={16} /> Maintenance
    </button>
  );
};

export default MaintenanceEntryButton;
